import React, {useState} from "react";
import { data } from "../data";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import { makeStyles } from "@material-ui/core/styles";
import { MathComponent } from "mathjax-react";
import "./Part1.css"
const useStyles = makeStyles((theme) => ({
	iconTop: {
		animation: "scrollTop 0.3s alternate ease infinite",
		width: "160px",
		height: "140px",
		color: "green",
	},
}));
const Part1 = () => {
	const { title, sub, subbab1, wordmateri, bupert, tanda } = data[0];
	const classes = useStyles();
	const [ukuranH,setUkuranH]=useState(19)
	const [ukuranP,setUkuranP]=useState(15)
	const sizeplus =()=>{
		setUkuranH(ukuranH+1)
		setUkuranP(ukuranP+1)
	}
	const sizemin =()=>{
		setUkuranH(ukuranH-1)
		setUkuranP(ukuranP-1)
	}
	return (
		<div>
			<div className="container">
			<div className="d-flex justify-content-end">
			<button className="btnplus" onClick={sizeplus}><h6>A<sub>+</sub></h6></button>
			<button className="btnplus" onClick={sizemin}><h6>A<sub>-</sub></h6></button>
			</div>
				<div className="row">
					<div className=" col-sm-3 col-md-12 col-lg-12">
						<div
							style={{
								fontSize: `${ukuranH}px`,
								width: "50%",
								color: "green",
								borderRadius: "25px",
							}}
						>
							<strong>{title}</strong>
						</div>
					</div>
					<div className="col-sm mt-2">
						<div
							style={{
								width: "100%",
								borderStyle: "inset",
								borderRadius: "25px",
								borderColor: "#70db70",
								paddingTop: "10px",
								textAlign: "justify",
								boxShadow: "5px 5px #888888",
								backgroundColor :"#f0f5f5",
							}}
						>
							<div className="col">
								<div
									style={{
										width: "100%",
										marginTop: "1rem",
										textAlign: "justify",
									
									}}
								>
									<div
										style={{
											textAlign: "justify",
											lineHeight: "20px",
											paddingRight: "10px",
										}}
									>
										{sub.map((item, index) => (
											<div key={index}>
												<ol style={{fontSize:`${ukuranP}px`}}>
													{item.no} {item.word}
												</ol>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					style={{
						marginTop: "3rem",
						color: "green",
					}}
				>
					<b style={{fontSize:`${ukuranH}px`}}>{subbab1}</b >
				</div>
				<div className="row">
					<div className="col-sm-12">
						<div
							style={{
								width: "100%",
								textAlign: "justify",
								lineHeight: "35px",
								fontSize:`${ukuranP}px`
							}}
						>
							{wordmateri}
						</div>
					</div>
				</div>
				{/* style={{display:'flex',justifyContent:'space-between',marginTop:'1rem', width:'80%',marginLeft:'80px'}} */}
				<div className="row">
					<div className="col-md-3 col-lg-3 offset-lg-1">
						<div style={{ width: "100%" }}>
							<ul style={{fontSize:`${ukuranP}px`}}>
								<li>
									<MathComponent tex={String.raw`ax + by > c `} />
								</li>
								<li>
									<MathComponent tex={String.raw`ax + by ≥ c `} />
								</li>
								<li>
									<MathComponent tex={String.raw`ax + by < c `} />
								</li>
								<li>
									<MathComponent tex={String.raw`ax + by ≤ c `} />
								</li>
							</ul>
						</div>
					</div>
					<div className="col-md-3 col-lg-3">
						<div style={{}}>
							<DoubleArrowIcon className={classes.iconTop} />
						</div>
					</div>
					<div className="col-sm-12 col-md-3 col-lg-3 mt-3">
						<div
							style={{
								width: "100%",
								lineHeight: "35px",
								fontSize:`${ukuranP}px`
							}}
						>
							{bupert}
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12 col-lg-12 mt-4">
						<p style={{fontSize:`${ukuranP}px`}}>Berikut ini adalah contoh pertidaksamaan linear dua variabel:</p>
						<ul
							style={{
								width: "20%",
								fontSize:`${ukuranP}px`
							}}
						>
							<li>
								<MathComponent tex={String.raw`2x + 3y > 6 `} />
							</li>
							<li>
								<MathComponent tex={String.raw`4x - y < 9 `} />
							</li>
						</ul>
					</div>
					<div className="col-sm">
						<p style={{ width: "100%", textAlign: "justify",fontSize:`${ukuranP}px` }}>
							Beberapa kalimat terbuka di atas menggunakan tanda hubung seperti{" "}
							<i>{tanda}</i>. Merupakan contoh pertidaksamaan linier dua variabel yang menandakan kalimat tersebut merupakan
							pertidaksamaan.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Part1;
